export const baseDev="";
export const baseProd="";
export const erpserver='https://overseas.goldenhighway.com/grouperpserver';
export const videoserver="https://overseas.goldenhighway.com/groupvideoserver";
export const videoplatserver="https://overseas.goldenhighway.com/groupvideoplatserver";
export const erpplatserver="https://overseas.goldenhighway.com/grouperpplatserver";
export const erpplatfileserver="https://overseas.goldenhighway.com/grouperpplatserverdown";
export const reportserver='https://overseas.goldenhighway.com/groupreportserver';
export const oaserver='https://overseas.goldenhighway.com/groupnewoaserver/';
export const flowserver='https://overseas.goldenhighway.com/groupflowserver/'
export const baseerp="overseas";
export const attendanceserver='https://overseas.goldenhighway.com/groupattendanceserver'//假勤服务

export const mqserver='https://overseas.goldenhighway.com/groupmqserver';
export const baseApp="groupweb";
export const baseVersion="9.5";

const pre=window.location.protocol==='https:'?'wss':'ws'
export const websocketUrl=pre+'://overseas.goldenhighway.com/groupwebsocketserver'//websocket新增
export const basePlat='ghw'//websocket新增

// 地址库电商
export const AddressLibrary='https://overseas.goldenhighway.com/ecomghwserver';
export const newfile_url="https://overseas.goldenhighway.com/groupfileserver";
export const file_url="https://overseas.goldenhighway.com/groupfileserver/mdownload/getfile.do?";
export const file_root="https://overseas.goldenhighway.com";
export const sse_url="https://overseas.goldenhighway.com/grouperpplatserver/sse";

export const sqEffectivedays=7;
export const baseLang=sessionStorage.getItem("vc_lang")?sessionStorage.getItem("vc_lang"):'zh_cn';